import { PCTheme } from "@permisso/permisso-components";
import { Theme } from "src/apps/providers/ThemeStore";

// PCProvider fills in anything left out with DefaultPCTheme, so this only needs to
// forward what documentation-area's customization actually sets. ctaSize/ctaMobileSize/
// ctaAlignment/integrationMode aren't returned by the documentation-area customization
// endpoint (unlike open-admin-app's session customization), so they're intentionally
// left out here and default via PCProvider.
export const mapToPCTheme = (theme: Theme): Partial<PCTheme> => ({
  primaryColor: theme.primaryColor,
  linkColor: theme.linkColor,
  visitedLinkColor: theme.visitedLinkColor,
  blackColor: theme.blackColor,
  errorColor: theme.errorColor,
  successColor: theme.successColor,
  tabBarColor: theme.tabBarColor,
  primaryButtonBackgroundColor: theme.primaryButtonBackgroundColor,
  primaryButtonTextColor: theme.primaryButtonTextColor,
  primaryButtonDisabledBackgroundColor: theme.primaryButtonDisabledBackgroundColor,
  primaryButtonDisabledTextColor: theme.primaryButtonDisabledTextColor,
  fontLinks: theme.fontLinks,
  fontFamily: theme.fontFamily,
  fontFamilyHeadings: theme.fontFamilyHeadings,
  fontSize: theme.fontSize,
  companyLogo: theme.companyLogo,
  companyName: theme.companyName,
});
